/*
|---------------------------------------------------------------------
| Órdenes de Trabajo — Realtime Vuex Module
|---------------------------------------------------------------------
|
| Suscripción GLOBAL (a nivel de sesión, mismo criterio que
| ticketsRealtime.js) al canal privado 'ordenes-trabajo-table', donde el
| backend emite dos eventos:
|
|   - orden-trabajo.actualizada: ping liviano (solo trae orden_trabajo_id)
|     ante cualquier alta/actualización/baja de una OT — incluye mover de
|     columna en el kanban. Lo consume tanto el listado (recarga la vista
|     activa) como el drawer de detalle, si es la OT que tiene abierta.
|   - orden-trabajo.mensaje.creado: nuevo mensaje en el hilo de una OT
|     (comentario, nota o actividad de sistema). Lo consume el drawer de
|     detalle para refrescar el hilo sin que el usuario tenga que recargar.
|
| No hay aquí una notificación "rica" tipo TicketRealtimeNotification —
| las 3 conductas pedidas (kanban en vivo, hilo en vivo, edición en vivo)
| se resuelven en el componente consumidor simplemente re-llamando a la
| acción de fetch que ya existe (cargarListado() / fetchDetalle()), no
| necesitan lógica adicional en el store.
|
*/
const OT_TABLE_CHANNEL = 'ordenes-trabajo-table'
const TABLA_EVENT = '.orden-trabajo.actualizada'
const MENSAJE_EVENT = '.orden-trabajo.mensaje.creado'

const state = {
  lastTableEvent: null,
  lastMensajeEvent: null,
  // Guard de idempotencia: subscribeOTRealtime se dispara tanto en
  // login/auth2fa como en App.vue created() — sin esto, si ambas llegan a
  // correr en la misma sesión, el canal queda escuchado dos veces.
  subscribed: false
}

const mutations = {
  SET_LAST_TABLE_EVENT: (state, payload) => {
    state.lastTableEvent = payload
  },

  SET_LAST_MENSAJE_EVENT: (state, payload) => {
    state.lastMensajeEvent = payload
  },

  SET_SUBSCRIBED: (state, value) => {
    state.subscribed = value
  }
}

const actions = {
  subscribeOTRealtime({ commit, state }) {
    if (typeof window === 'undefined' || !window.Echo) return
    if (state.subscribed) return
    try {
      window.Echo.private(OT_TABLE_CHANNEL)
        .listen(TABLA_EVENT, (e) => {
          commit('SET_LAST_TABLE_EVENT', { ...e, _receivedAt: Date.now() })
        })
        .listen(MENSAJE_EVENT, (e) => {
          commit('SET_LAST_MENSAJE_EVENT', { ...e, _receivedAt: Date.now() })
        })
        // pusher:subscription_error: la conexión de bajo nivel puede seguir
        // "connected" mientras la autorización de ESTE canal privado falló
        // (mismo caso documentado en ticketsRealtime.js).
        .error((error) => {
          console.warn('Fallo al autorizar el canal ordenes-trabajo-table (WebSocket):', error)
        })
      commit('SET_SUBSCRIBED', true)
    } catch (error) {
      // Echo es opcional; si falla, el front sigue funcionando sin tiempo real.
      console.warn('No se pudo suscribir a ordenes-trabajo-table:', error)
    }
  },

  unsubscribeOTRealtime({ commit }) {
    commit('SET_SUBSCRIBED', false)
    if (typeof window === 'undefined' || !window.Echo) return
    try {
      window.Echo.leave(OT_TABLE_CHANNEL)
    } catch (error) {
      // noop
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
